///////////////////////////////////////////////////////////////////////////////
export const createAbsoluteLink = (url) => {
  if (url === "#") {
    return null
  }

  return `${process.env.GATSBY_SITE_URL}${url}`
}
